import { IntegrationStatus } from '@/modules/common/types/integration-status';
import { IntegrationState } from '@/modules/common/types/integrations';

/**
 * Maps integration status from API to IntegrationState enum used in UI
 */
export const mapStatusToIntegrationState = (status: IntegrationStatus): IntegrationState => {
  switch (status) {
    case IntegrationStatus.Connected:
      return IntegrationState.CONNECTED;
    case IntegrationStatus.Error:
      return IntegrationState.ERROR_CONNECTION;
    case IntegrationStatus.Syncing:
      return IntegrationState.SYNCING;
    case IntegrationStatus.Unknown:
    default:
      return IntegrationState.NOT_CONNECTED;
  }
};
